import styled from "styled-components";
import BG from '@/img/sku/bg@2x.png';


export const Container = styled.div`
  background-image: url(${BG});
  background-size: cover;
  background-repeat: no-repeat;
  margin-top: 44px;
  background-color: #202020;
  .input-wrap {
    padding-top: 246px;
    padding-left: 35px;
    padding-right: 35px;
  }
  .input-container {
    background: #090909;
    height: 48px;
    border-radius: 24px;
  }
  .sku-input {
    box-sizing: border-box;
    padding: 0 20px;
    width: 100%;
    height: 100%;
    border: none;
    background: unset;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    color: #fff;
  }
  .confirm-wrap {
    margin: 21px auto 0;
    width: 303px;
    height: 49px;
  }
  .sku-confirm {
    width: 100%;
  }
  .footer-wrap {
    margin-top: 43px;
    font-size: 14px;
    line-height: 20px;
    font-weight: bold;
    color: rgba(255, 255, 255, 0.43);
    padding: 0 32px 50px;
  }
  .footer-wrap-title {
    font-size: 16px;
    line-height: 20px;
  }
  .fotter-line {
    margin-top: 10px;
  }
  .desc-text {
    margin-left: 0px;
  }
`;

export const ModalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .modal-container {
    width: 280px;
    height: 246px;
    background: #fff;
    border-radius: 13px;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .img-wrap {
    width: 72px;
    height: 73px;
    padding-top: 28px;
  }
  .btn-wrap {
    width: 236px;
    height: 38.5px;
    margin-top: 18.6px;
  }
  .font-wrap {
    width: 82px;
    height: 19px;
    margin-top: 5px;
  }
  .img {
    width: 100%;
    height: 100%;
  }
  .label {
    font-size: 13px;
    line-height: 1;
    margin-top: 17px;
    font-weight: 400;
    color: #757575;
  }
`;


// WEBPACK FOOTER //
// ./src/views/sku-exchange/style.js